module.exports = __webpack_public_path__ + "img/T6-B-xh_9.c96e221f.png";